import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/assets/scss/layout/_main-wrapper.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var MainWrapper = function MainWrapper(_ref) {
  var children = _ref.children,
      extraClasses = _ref.extraClasses,
      full = _ref.full,
      rest = _objectWithoutProperties(_ref, ["children", "extraClasses", "full"]);

  // defines base block class name
  var bem = HoneyBem('main-wrapper', styles);
  return React.createElement("section", _extends({
    className: bem.b({
      full: full
    }, extraClasses)
  }, rest), children);
};
MainWrapper.displayName = 'MainWrapper';
MainWrapper.defaultProps = {
  extraClasses: '',
  full: null
};
MainWrapper.propTypes = {
  children: PropTypes.node.isRequired,

  /** Custom classes name for tooltip element */
  extraClasses: PropTypes.string,

  /** Makes component occupying the whole viewport */
  full: PropTypes.bool
};
var mainWrapper = Injecss(MainWrapper, styles);

export default mainWrapper;
export { MainWrapper };
